class UnsavedChangesConfirmationService {
  public hasChanges = (): boolean => null;

  public showConfirmationDialog = false;
}

const Instance = new UnsavedChangesConfirmationService();
export default Instance;
